import { CalendarPrintSettingsBase } from './CalendarPrintSettings.base';
import type {
    CalendarPrintSettingsProps,
    CalendarPrintSettingsStyleProps,
    CalendarPrintSettingsStyles,
} from './CalendarPrintSettings.types';
import { styled } from '@fluentui/react/lib/Utilities';

export type { CalendarPrintSettingsProps };

/** The default style of CalendarPrintSettings */
export function getStyles(
    styleProps: CalendarPrintSettingsStyleProps
): CalendarPrintSettingsStyles {
    return {
        root: [
            'ms-CalendarPrintSettings',
            {
                minWidth: '250px',
                selectors: {
                    '& > div, & > button': {
                        paddingBottom: '22px',
                    },
                    '& > button': {
                        paddingTop: '5px',
                    },
                },
            },
            styleProps.className,
        ],
    };
}

/** The default styled version of CalendarPrintSettings */
export const CalendarPrintSettings = styled<
    CalendarPrintSettingsProps,
    CalendarPrintSettingsStyleProps,
    CalendarPrintSettingsStyles
>(CalendarPrintSettingsBase, getStyles);
